/**
 * @file GameSkinAudioSources.ts
 * @role Discovers encoded Lucky Lights runtime audio without requiring a code edit for each
 *       correctly named WebM+MP3 pair dropped into the skin's audio directory.
 * @owns The build-time Vite glob for the current skin.
 * @neverDoes Load or play audio. Register files with Pixi Assets.
 */
import { buildAudioSourceCatalog } from '@core/audio/SoundCatalog';

const luckyLightsRuntimeAudio = import.meta.glob<string>(
  '../assets/themes/lucky-lights/audio/*.{webm,mp3}',
  {
    eager: true,
    import: 'default',
    query: '?url&no-inline',
  },
);

export const LUCKY_LIGHTS_AUDIO_SOURCES = buildAudioSourceCatalog(luckyLightsRuntimeAudio);
